var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("JobsOccupationsResume", {
        attrs: {
          jobs: _vm.value.perimeter_jobs,
          occupations: _vm.value.perimeter_occupations,
          displayWishes: false,
          evaluatedOccupationSkills: _vm.value.occupations_skills,
          "display-collapses": true,
          "occupation-skills-goals": _vm.value.occupation_skills_goals,
          jobColors: _vm.jobColors,
          occupationColors: _vm.occupationColors,
        },
      }),
      _vm._v(" "),
      _c(
        "vs-row",
        {
          staticClass: "mt-10 p-5",
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.1)" },
        },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full p-0" }, [
            _c("span", { staticClass: "font-bold text-lg" }, [
              _vm._v("Souhaits de la personne :"),
            ]),
          ]),
          _vm._v(" "),
          _c("vs-col", { staticClass: "sm:w-4/5 w-full" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "py-5 mt-1 ml-5" },
        [
          _c(
            "vs-row",
            { staticClass: "mb-6 mt-10" },
            [
              _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                _c("span", [
                  _vm._v(
                    "\n                    Expérience(s) :\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "vs-col",
                { staticClass: "sm:w-4/5 w-full" },
                [
                  _c(
                    "Multiselect",
                    {
                      attrs: {
                        id: "wantedJobs",
                        options: _vm.jobs,
                        multiple: true,
                        "group-values": "jobs",
                        "group-label": "establishmentService",
                        "group-select": true,
                        placeholder: "Recherche ...",
                        "track-by": "uid",
                        label: "title",
                        "select-label": "",
                        "select-group-label": "",
                        "selected-label": "",
                        "deselect-label": "",
                        "deselect-group-label": "",
                        disabled:
                          _vm.typeForm === "validation" ||
                          _vm.typeForm === "consultation",
                      },
                      model: {
                        value: _vm.resource.wishlist_jobs,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "wishlist_jobs", $$v)
                        },
                        expression: "resource.wishlist_jobs",
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noResult" }, slot: "noResult" },
                        [_vm._v("Aucun résultat.")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-row",
            { staticClass: "mb-6" },
            [
              _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                _c("span", [
                  _vm._v("\n                    Métier(s) :\n                "),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "vs-col",
                { staticClass: "sm:w-4/5 w-full" },
                [
                  _c(
                    "Multiselect",
                    {
                      attrs: {
                        id: "wantedOccupations",
                        multiple: "",
                        options: _vm.occupations,
                        "group-label": "type",
                        "group-values": "occupations",
                        "group-select": false,
                        label: "title",
                        disabled:
                          _vm.typeForm === "validation" ||
                          _vm.typeForm === "consultation",
                        placeholder: "Recherche ...",
                        "track-by": "uid",
                        "select-label": "",
                        "select-group-label": "",
                        "selected-label": "",
                        "deselect-label": "",
                        "deselect-group-label": "",
                        loading: _vm.referentialOccupations.loading,
                      },
                      model: {
                        value: _vm.resource.wishlist_occupations,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "wishlist_occupations", $$v)
                        },
                        expression: "resource.wishlist_occupations",
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noResult" }, slot: "noResult" },
                        [_vm._v("Aucun résultat.")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("OccupationSkillsGoal", {
        attrs: {
          "occupation-skills": _vm.occupationSkillsAvailables,
          readonly: _vm.typeForm === "consultation",
          themes: _vm.themes.data.filter((t) => t != "Compétence"),
          states: _vm.states.data,
          jobColors: _vm.jobColors,
          occupationColors: _vm.occupationColors,
        },
        model: {
          value: _vm.resource.occupation_skills_goals,
          callback: function ($$v) {
            _vm.$set(_vm.resource, "occupation_skills_goals", $$v)
          },
          expression: "resource.occupation_skills_goals",
        },
      }),
      _vm._v(" "),
      !_vm.occupationSkillRatingOnly
        ? _c("SkillsGoal", {
            attrs: {
              skills: _vm.value.skills,
              readonly: _vm.typeForm === "consultation",
              themes: _vm.themes.data.filter((t) => t != "Savoir-faire"),
              states: _vm.states.data,
              jobColors: _vm.jobColors,
              occupationColors: _vm.occupationColors,
            },
            model: {
              value: _vm.resource.skills_goals,
              callback: function ($$v) {
                _vm.$set(_vm.resource, "skills_goals", $$v)
              },
              expression: "resource.skills_goals",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("OthersGoal", {
        attrs: {
          readonly: _vm.typeForm === "consultation",
          states: _vm.states.data,
          themes: _vm.themes.data,
          jobColors: _vm.jobColors,
          occupationColors: _vm.occupationColors,
        },
        model: {
          value: _vm.resource.others_goals,
          callback: function ($$v) {
            _vm.$set(_vm.resource, "others_goals", $$v)
          },
          expression: "resource.others_goals",
        },
      }),
      _vm._v(" "),
      _c(
        "vs-row",
        {
          staticClass: "mt-10 p-5",
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.1)" },
        },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full p-0" }, [
            _c("span", { staticClass: "font-bold text-lg" }, [
              _vm._v("Synthèse du projet :"),
            ]),
          ]),
          _vm._v(" "),
          _c("vs-col", { staticClass: "sm:w-4/5 w-full" }),
        ],
        1
      ),
      _vm._v(
        "\n\n    Liste des commentaires des évaluations et de l'auto-évaluation Portail\n    "
      ),
      _c(
        "vs-row",
        { staticClass: "mt-20 mb-30" },
        [
          _vm._l(_vm.value.externals, function (rating, i) {
            return _c(
              "vs-col",
              { key: `external_${i}`, staticClass: "sm:w-1/2 w-full" },
              [
                _c("h3", { staticClass: "mb-6 pl-5" }, [
                  _vm._v(
                    "Commentaires de\n                " +
                      _vm._s(
                        rating.creator ? rating.creator.first_name : "n/c"
                      ) +
                      "\n                " +
                      _vm._s(
                        rating.creator ? rating.creator.last_name : "n/c"
                      ) +
                      " :\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "vs-row",
                  [
                    _c(
                      "vs-col",
                      { staticClass: "sm:w-4/5 w-full" },
                      _vm._l(rating.comment, function (comment, type) {
                        return _c("div", { key: `external_type_${type}` }, [
                          _c("div", [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.getQuestionLabelFromSlug(type)) +
                                  " :"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: { innerHTML: _vm._s(comment) },
                          }),
                        ])
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.value.personals, function (rating, i) {
            return _c(
              "vs-col",
              { key: `personal_${i}`, staticClass: "sm:w-1/2 w-full" },
              [
                _c("h3", { staticClass: "mb-6 pl-5" }, [
                  _vm._v("Commentaires de l'auto-évaluation :"),
                ]),
                _vm._v(" "),
                _c(
                  "vs-row",
                  [
                    _c(
                      "vs-col",
                      { staticClass: "sm:w-4/5 w-full" },
                      _vm._l(rating.comment, function (comment, type) {
                        return _c("div", { key: `external_type_${type}` }, [
                          _c("div", [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.getQuestionLabelFromSlug(type)) +
                                  " :"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: { innerHTML: _vm._s(comment) },
                          }),
                        ])
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.resource.comment || Object.values(_vm.resource.comment).length == 0
        ? _vm._l(_vm.ratingFields, function (ratingField) {
            return _c(
              "vs-row",
              { key: ratingField.id, staticClass: "mb-20 mt-10" },
              [
                _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                  _c("span", { staticClass: "font-bold text-lg" }, [
                    _vm._v(_vm._s(ratingField.name) + " :"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "vs-col",
                  { staticClass: "sm:w-4/5 w-full" },
                  [
                    _c("quill-editor", {
                      attrs: {
                        value: _vm.resource.comment[ratingField.name],
                        name: "ratingField" + ratingField.id,
                        options: _vm.options,
                        disabled: _vm.typeForm === "consultation",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.debouncedInputHandleComment(
                            $event,
                            ratingField.name
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          })
        : _vm._l(
            Object.keys(_vm.resource.comment),
            function (ratingFieldName, i) {
              return _c(
                "vs-row",
                { key: `comment_${i}`, staticClass: "mb-20 mt-10" },
                [
                  _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                    _c("span", { staticClass: "font-bold text-lg" }, [
                      _vm._v(_vm._s(ratingFieldName) + " :"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "vs-col",
                    { staticClass: "sm:w-4/5 w-full" },
                    [
                      _c("quill-editor", {
                        attrs: {
                          value: _vm.resource.comment[ratingFieldName],
                          name: "ratingField" + i,
                          options: _vm.options,
                          disabled: _vm.typeForm === "consultation",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.debouncedInputHandleComment(
                              $event,
                              ratingFieldName
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }